<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="square-jelly-box" [fullScreen]="true">
  <p style="color: white"> Loading... </p>
</ngx-spinner>

<div class="header-container">
  <div class="logo-container">
    <a (click)="toggleSidebar()" href="#" class="sidebar-toggle">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <a class="logo" href="#" (click)="navigateHome()"><span>
        <img [src]="srcname">
      </span></a>



  </div>

</div>
<div class="header-container">
  <a class="header-title" href="#" (click)="navigateHome()"><span>Dindigul Camara Rental</span></a>
</div>
<div class="header-container">
    <nb-select class="displayNone" [selected]="currentTheme" (selectedChange)="changeTheme($event)" status="primary">
      <nb-option *ngFor="let theme of themes" [value]="theme.value"> {{ theme.name }}</nb-option>
    </nb-select>
    <nb-actions size="small displayNone">

      <!-- <nb-action class="control-item">
      <nb-search type="rotate-layout"></nb-search>
    </nb-action> -->
      <nb-action class="user-action header-user " *nbIsGranted="['view', 'user']">
        <nb-user [nbContextMenu]="userMenu" [onlyPicture]="userPictureOnly" [name]="user?.username" [title]="user?.role"
          [picture]="user?.imageUrl" href="">
        </nb-user>
      </nb-action>
    </nb-actions>
  <!-- <div class="btn btn-primary btn-block p-1 w-75" role="button" *ngIf=" user?.role !=   null" (click)="logout()">
    Logout
  </div> -->
  <div class="btn btn-primary btn-block p-1  w-50" role="button" id="loginButton" *ngIf=" user?.role == null"
    (click)="showRegistraion();">
    Login
  </div>
</div>
<div class="succesfull-info-popup" [ngClass]="{ 'open': faild }">
  <i class="far fa-thumbs-up"></i> <span> Logout Successfully</span>
</div>

<div [ngStyle]="{'display': registrationShow ? 'block'  : 'none' }" class="component-contents">
  <div class="lightbox-model open ">
    <div class="lightbox-contents" style="width: 351px !important;">
      <div class="lightbox-header clearfix">
        <div class="lightbox-title lightbox-title-bill">
          <span class="popu-billamo">Login & SignUp</span>
        </div>
        <div class="lightbox-close" (click)="registrationShow=false">
          <i class="fa fa-times" aria-hidden="true"></i>
        </div>
      </div>
      <div class="">
        <div class="tab-block-conetnts">
          <ngx-customer-registration-login></ngx-customer-registration-login>
          <div class="row">
            <div class="col-md-12">
              <div class="button-controls pb-1">
                <input type="button" (click)="registrationShow=false" value="Cancel" class="btn btn-clear" />
              </div>
            </div>
          </div>
          <!--  -->
        </div>
      </div>
    </div>
  </div>
</div>

<!-- my orders -->

<!-- <div class="modal displayNone" tabindex="-1" role="dialog" [ngStyle]="{'display': myorderPopup ? 'block'  : 'none' }">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header head-color">
        <h4 class="modal-title un-colorc">My Orders</h4>
        <button type="button" class="close" aria-label="Close" (click)="myOrderClose()"><span
            aria-hidden="true">&times;</span></button>
      </div>
      <div class="modal-body p-0">
        <ngx-my-orders></ngx-my-orders>
      </div>
      <div class="modal-footer head-color">
        <button type="button" class="btn btn-default" (click)="myOrderClose()">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="succesfull-info-popup" [ngClass]="{ 'open': popupAlert }">
  <i class="far fa-thumbs-up"></i> <span>{{popupMessage}} </span>
</div> -->
